import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-wohnort',
    templateUrl: './input-field.component.html'
} )
export class CityComponent extends AbstractFieldComponent<string>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.city' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.city = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.city;
    }
}
